import AutoNumeric from "autonumeric";
import { autonumericOptions, initCurrencyInput, initPercentageInput } from "./custom/autonumeric";
import { initDescription } from "./custom/autodescription";
import { changeAddIcon, changeRemoveIcon, changeDeleteInput } from "./custom/trasform_nested";
import {initCheckChiusura, initChiusuraCassa, initRefreshDocumentLocation} from "./custom/chiusura_cassa";
import { initProjectForm, checkAmount } from "./custom/project"
import { initSospeso, refreshParentSospeso } from "./custom/sospeso";
import { initAmountShareCascading, initCloneAmount, initOnChangeAmountShare } from "./custom/amount_share";
import { loadItemProjects, udpSelectAll, initChangeUDP } from "./custom/udp";
import { createNewCounterpart } from "./custom/counterpart";
import { initChangeDocumentType} from "./custom/document_type";
import {initFormTab} from "./custom/form_tab";
import { initRefreshStatusImport } from "./custom/invoices";
import {initRefreshStatusAiJob} from "./custom/journal_entries";

$(document).ready(function () {

    ///////////////////////////////////////////////////////////
    ////////////////////////// GLOBALI
    // INIT currency field
    $('input.currency').each(function (i, el) {
        initCurrencyInput(el)
    })

    // INIT percentage field
    $('input.percentage').each(function (i, el) {
        initPercentageInput(el)
    })

    // EVENTO dopo click rimozione riga di elementi nested
    $(document).on('has_many_remove:after', function (e, f) {
        initCloneAmount();
    })

    // EVENTO dopo click aggiunta nuova riga di elementi nested
    $(document).on('has_many_add:after', function (e, f) {
        const fieldset = $(f)
        const sortFunction = data => data.sort((a, b) => a.text.localeCompare(b.text));
        fieldset.find('.select2').each(function (i, el) {
            $(el).select2({theme: "classic", language: "it", width: '100%', sorter: sortFunction});
        })
        fieldset.find('input.currency').each(function (i, el) {
            initCurrencyInput(el)
        })
        fieldset.find('input.percentage').each(function (i, el) {
            initPercentageInput(el, true)
        })
        fieldset.each(function (i, c) {
            changeRemoveIcon($(c))
            changeDeleteInput($(c))
            changeAddIcon($(c), "");
        });
        initCloneAmount();
        initOnChangeAmountShare();
        initAmountShareCascading();
    });

    $('.has-many-container').each(function (i, c) {
        changeAddIcon($(c), "");
        $(c).find("> fieldset").each(function (i, c) {
            changeRemoveIcon($(c))
            changeDeleteInput($(c))
        });
    });
    ////////////////////////// GLOBALI
    ///////////////////////////////////////////////////////////


    /////// FORM amount share
    initOnChangeAmountShare();
    initAmountShareCascading();

    initCloneAmount();
    $('form.journal_entry #journal_entry_amount').trigger('change.sum-amount')
    /////// FORM amount share



    ////// DETTAGLIO piano e UDP
    loadItemProjects();
    ////// DETTAGLIO piano e UDP
    ////// FORM UDP
    udpSelectAll();
    ////// FORM UDP


    //////////////////////////////////////////////////////////////////////////////
    /////////////// FORM Journal Entry
    initChangeUDP();
    initChangeDocumentType();
    createNewCounterpart();
    initSospeso();
    initDescription();
    initRefreshStatusAiJob();
    /////////////// FORM Journal Entry
    //////////////////////////////////////////////////////////////////////////////


    /////////////// FORM CHIUSURA CASSA
    initChiusuraCassa();
    initRefreshDocumentLocation();
    initCheckChiusura();
    /////////////// FORM CHIUSURA CASSA

    ///////// FORM Project
    checkAmount();
    initProjectForm();
    ///////// FORM Project


    /////// Invoice /////
    initRefreshStatusImport()
    ////////////////////////

});


// CARICA DOCUMENTO LOCATION al change payment_method ma non serve più
// function initChangePaymentMethod() {
//     const $element = $('form.journal_entry #journal_entry_payment_method_id')
//     const $documentLocationSelect = $('form.journal_entry #journal_entry_document_location_id')
//
//     $element.on('change', function (e) {
//         const optionSelected = $("option:selected", this);
//         const identifier = (optionSelected.data('identifier'))
//         // const ajaxTypes = ['pagamento_fornitore', 'incasso_cliente']
//         // if (ajaxTypes.includes(identifier)) {
//         $.getJSON(`/admin/journal_entries/document_locations?payment_method_id=${this.value}`, function (data) {
//             const autoSelect = data.length === 1
//             const alreadySelected = parseInt($documentLocationSelect.find('option:selected')?.val());
//             $documentLocationSelect.find('option').remove()
//             const newOption = new Option(" ", '', false, false);
//             !autoSelect && $documentLocationSelect.append(newOption);
//             $.each(data, function (i, d) {
//                 const newOption = new Option(d[0], d[1], false, autoSelect || (alreadySelected === d[1]));
//                 d[2] && newOption.setAttribute("data-identifier", d[2]['data-identifier'])
//                 $documentLocationSelect.append(newOption);
//             })
//             $documentLocationSelect.trigger('');
//         });
//     });
//
// }



















